<div *ngFor="let error of model" class="alert alert-danger">
    <span>{{error}}</span>
</div>
